export default "__VITE_ASSET__80186ce2__"